export const toast = (msg, type = "success") => {
  const el = document.createElement("div");
  el.innerText = msg;

  const bg = type === "error" ? "#ef4444" : "#22c55e";

  Object.assign(el.style, {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    background: bg,
    color: "#fff",
    padding: "12px 18px",
    borderRadius: "10px",
    fontSize: "14px",
    zIndex: 9999,
    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
  });

  document.body.appendChild(el);

  setTimeout(() => {
    el.remove();
  }, 3000);
};
